define('views/components/customer_product/customer_product',['require','backbone','context/basket','models/basket_product','text!templates/components/customer_product/customer_product.html'],function(require){

    var Backbone = require('backbone');
    var Basket = require('context/basket');
    var BasketProductModel = require('models/basket_product');

    var temp = require("text!templates/components/customer_product/customer_product.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'customer-product-item',

        initialize: function() {
            // Add expired class if license expired
            if (this.model.get('end_time') && new Date(this.model.get('end_time')) < new Date()) {
                this.$el.addClass('expired');
            }
        },

        ui: function() {
            return {
                extendButton: '#extend-button',
                revokeButton: '#revoke-button'
            };
        },

        events: {
            'click @ui.extendButton': 'extendButtonClicked',
            'click @ui.revokeButton': 'revokeButtonClicked'
        },

        extendButtonClicked: function () {
            // Clear basket first
            // App.context.basket = new Basket();

            // Add product to basket

            var _this = this;

            // Add product to basket, if not exists
            if (!App.context.basket.get('products').find(function (basketProduct) {
                return basketProduct.license === _this.model.get('id');
            })) {
                var basketProduct = new BasketProductModel({
                    product: this.model.get('product'),
                    count: 1,
                    license: this.model.get('id')
                });
                App.context.basket.get('products').push(basketProduct.attributes);
    
                if(App.user.get("customer")){
                    var iconContainer = document.createElement('div');
                    iconContainer.setAttribute("class","icon-container");
                
                    var butonRect = this.el.querySelector('#extend-button').getBoundingClientRect();
                    var a = this.el.querySelector('#extend-button'). getClientRects();
        
                    var yTop = butonRect.top;
                    var xLeft =  butonRect.left ;
            
                    var basketIcon = document.createElement('i');
                    basketIcon.setAttribute('class', 'fa fa-shopping-basket basket-icon');
                    basketIcon.setAttribute('style', 'top:' + yTop + 'px;left:' + xLeft + 'px;');
        
                    iconContainer.append(basketIcon);
        
                    $('#sidebar').append(iconContainer);
        
        
                    setTimeout(function () {
                        App.vent.trigger('basket-updated');
                        iconContainer.remove();
                    }, 3*1000);
                }else{
    
                    App.vent.trigger('basket-updated');

                    // Show success message
                    App.utils.showMessage('success', App.polyglot.t('add_to_basket_success'));
    
                }

            } else {
                // Already in basket
                App.utils.showMessage('warning', App.polyglot.t('already_in_basket'));
            }





            // Redirect to checkout page
            // App.context.redirect('/checkout');
        },
        revokeButtonClicked: function () {
            var _this = this;
            App.utils.showConfirmModal(App.polyglot.t('revoke_license_confirm_message'), function () {
                _this._revoke();
            });
        },

        _revoke: function () {
            var _this = this;

            $.ajax({
                url: App.Config.apiBase + 'customer-licenses/' + this.model.get('id') + '/revoke/',
                method: 'post',
                success: function (response) {
                    _this.model.collection.remove(_this.model);

                    App.utils.showMessage('success', App.polyglot.t('revoke_success'));
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    // Show error messages
                    if (xhr.responseJSON.errors) {
                        for (var i = 0; i < xhr.responseJSON.errors.length; i++) {
                            App.utils.showMessage('error', xhr.responseJSON.errors[i].message);
                        }
                    }
                }
            });
        }

    });
});
